import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usr-screenaccesscontrolthree',
  templateUrl: './usr-screenaccesscontrolthree.component.html',
  styleUrls: ['./usr-screenaccesscontrolthree.component.css']
})
export class UsrScreenaccesscontrolthreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
